"use client";
import { InfoAlert } from "@components/CustomAlert";
import { useEffect, useState } from "react";
import { useHasMounted } from "@core/hooks/useHasMounted";
import {
  getMessaging,
  isSupported,
  onMessage,
  MessagePayload,
} from "firebase/messaging";
import { app } from "../app";

export const validateMessaging = async () => {
  const supported = await isSupported();
  if (supported) return getMessaging(app);
  return;
};

export const Messaging = () => {
  const [newPayload, setPayload] = useState<MessagePayload | undefined>();
  const hasMounted = useHasMounted();

  const playSound = () => {
    const audio = new Audio("/sounds/AlertAudio.mp3");
    audio.play();
  };

  useEffect(() => {
    const listenMessage = async () => {
      try {
        const messaging = await validateMessaging();
        if (!messaging) throw "Undefined Messaging in listening";
        const unsubscribe = onMessage(messaging, (payload) => {
          setPayload(payload);
        });
        if (newPayload) {
          playSound();
          InfoAlert((newPayload as MessagePayload).notification?.title ?? "");
          setPayload(undefined);
        }
        return unsubscribe;
      } catch (error) {
        console.log("ERRORRRRR getting message", error);
      }
    };
    listenMessage();
  }, [newPayload]);

  //ESTO SE USA PARA PROBAR SI SE PUEDE REPRODUCIR UN SONIDO EN EL SERVICE-WORKER
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data.type === "PLAY_SOUND") {
          playSound();
        }
      });
    }
  }, []);
  if (!hasMounted) return null;
  return null;
};
